/* tslint:disable */
/* eslint-disable */
/**
 * SENGO Platform Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.27
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const FeedbackModerationStatus = {
    Kept: 'Kept',
    Removed: 'Removed',
} as const;

export type FeedbackModerationStatus = typeof FeedbackModerationStatus[keyof typeof FeedbackModerationStatus];



